import { FormField, FormFieldType } from '~forms/types';

/**
 * Builds a fresh FormField of the given type with sensible defaults.
 *
 * Single source of truth for new-field construction — used by both the click-to-add path
 * (FieldPalette) and the drag-and-drop path (FormTemplateBuilder.handleDragEnd) so a field
 * type only needs its defaults defined once.
 */
export function makeDefaultField(type: FormFieldType): FormField {
  const base = {
    id: crypto.randomUUID(),
    label: '',
    required: false,
    read_only: false,
    include_in_pdf: true,
    conditional_logic: null as null,
  };

  if (type === 'multiple_choice' || type === 'dropdown') {
    return { ...base, type, options: [], allow_multiple: false };
  }
  if (type === 'section_divider') {
    return { ...base, type };
  }
  if (type === 'merge_field') {
    // Merge fields are clipboard-only and never added as standalone canvas fields; here for exhaustiveness.
    return { ...base, type, read_only: true, merge_token: '' };
  }
  if (type === 'rich_text') {
    // Read-only formatted content block — no label/prefill/required; the content is the field.
    return { ...base, type, read_only: true, content: '' };
  }
  // type is now narrowed to the primitive field types (text/paragraph/date/checkbox/signature).
  return { ...base, type };
}
